// extracted by mini-css-extract-plugin
export default {"socials":"social-links__socials___MM2fI","socialsWrapper":"social-links__socialsWrapper___rT4jz","divider":"social-links__divider___O3SnF"};